/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Channel_Location_ValueInputs */

const en_contact_channel_location_value = /** @type {(inputs: Contact_Channel_Location_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liepāja, Latvia`)
};

const lv_contact_channel_location_value = /** @type {(inputs: Contact_Channel_Location_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liepājā, Latvijā`)
};

/**
* | output |
* | --- |
* | "Liepāja, Latvia" |
*
* @param {Contact_Channel_Location_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_channel_location_value = /** @type {((inputs?: Contact_Channel_Location_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Channel_Location_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_channel_location_value(inputs)
	return en_contact_channel_location_value(inputs)
});